<template>
<div class="chapter">
<div class="inner_page">
<div> <a id="list"></a></div>
<p class="fronthead">ILLUSTRATIONS</p>
<p class="toc"><a href="#/html/005_map#list0"><i>Map of the River Ouse</i>, by Helen Macdonald</a></p>
<p class="toc"><a href="#/html/010_il1#list1"><i>The River Ouse</i>. Photograph by the author.</a></p>
<p class="toc"><a href="#/html/012_il2#list2"><i>Gideon Algernon Mantell</i>, by William Turner Davey, published by L. Buck, after Pierre Athasie Théodore Senties, and John Jabez Edwin Mayall. Mezzotint,
  circa 1850. Copyright © National Portrait Gallery, London.</a></p>
<p class="toc"><span href="#/html/014_il3#list3" title="Link target outside of Sample"><i>Upper Hell</i>, by C. W. Scott-Giles, from <i>Hell</i>, book one of Dante’s <i>Divine Comedy</i>, translated by Dorothy L. Sayers and first published by
  Penguin in 1949.</span></p>
<p class="toc"><span href="#/html/016_il4#list4" title="Link target outside of Sample"><i>Simon de Montfort, Earl of Leicester</i>, circa 1231.<br/>
  Copyright © Hulton Archive/Getty Images</span></p>
<p class="toc"><span href="#/html/018_il5#list5" title="Link target outside of Sample"><i>The reconstructed skull of ‘Piltdown Man’</i>, circa 1950.<br/>
  Copyright © Popperphoto/Getty Images.</span></p>
<p class="toc"><span href="#/html/020_il6#list6" title="Link target outside of Sample"><i>Virginia Woolf</i>. Copyright © Press Association</span></p>
<p class="toc"><span href="#/html/022_il7#list7" title="Link target outside of Sample"><i>Leonard Woolf</i>, first published alongside ‘Do We Read Better Books in Wartime’ in the <i>Picture Post</i>, 1944. Copyright © Felix Man and
  Kurt Jutton/Picture Post/Hulton Archive/Getty Images.</span></p>
<p class="toc"><span href="#/html/024_il8#list8" title="Link target outside of Sample"><i>Lieutenant Ackery’s Crash</i>. Copyright © Henry Ross Alderson/climb-out.co.uk.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 008_loi.vue?7339ff69